import React, { useState, useEffect } from "react"
import { post, get } from "./../utils/apiClient"
import PdfViewer from "./common/pdfViewver"

const prePopulateFaxNumberCodes = [
  "E06",
  "E07",
  "E33",
  "E43",
  "E41",
  "E42",
  "E44",
  "E45",
  "E46",
  "E49",
]

const FaxView = ({ selectedFax, setSelectedFax, fetchFaxes, selectedTab }) => {
  const [fax, setFax] = useState({})
  const [showPopup, setShowPopup] = useState(false)
  const [loading, setLoading] = useState(false)
  const [loadingResend, setLoadingResend] = useState(false)
  const [recipientFaxNum, setRecipientFaxNum] = useState("")
  const [recipientName, setRecipientName] = useState("")
  const [errorMessage, setErrorMessage] = useState("")
  const [transferComplete, setTransferComplete] = useState(false)
  //const [pdfUrl, setPdfUrl] = useState(null)
  const [docImage, setDocImage] = useState(null)

  const handleButtonClick = (selectedAction) => {
    if (selectedAction === "Download") {
      // Trigger download
      const link = document.createElement("a")
      link.href = `data:image/jpeg;base64,${fax.image}`
      link.download = fax.file_name
      link.click()
    } else if (selectedAction === "Resend") {
      const flgPrePopulate = prePopulateFaxNumberCodes.some((code) =>
        selectedFax?.efaxTransmissionStatus.includes(code)
      )
      if (flgPrePopulate) {
        setRecipientFaxNum(selectedFax?.destFaxNum)
      }
      setRecipientName(selectedFax?.recipientName)
      setShowPopup(true)
    }
  }

  function validateFaxNumber(faxNumber) {
    const cleanedFaxNumber = faxNumber.replace(/[^\d]/g, "")

    const regex = /^(1[2-9][0-9]{9}|[2-9][0-9]{9})$/

    if (regex.test(cleanedFaxNumber)) {
      return true
    }

    return false
  }

  const handlePopupSubmit = async (e) => {
    e.preventDefault()
    setErrorMessage("")

    if (!recipientFaxNum) {
      setErrorMessage("Recipient fax number is required")
      return
    }

    const isValidated = validateFaxNumber(recipientFaxNum.trim())

    if (!isValidated) {
      setErrorMessage("Invalid recipient fax number")
      return
    } else {
      // setErrorMessage("correct")
      // return
    }

    setLoadingResend(true)
    try {
      await post("/fax/reSendFax", {
        faxId: selectedFax.faxId,
        recipientFaxNum,
        recipientName,
        selectedTab: selectedTab,
        jobId: selectedFax.printJobId,
        sendingUser: selectedFax.sendingUser,
        // recipientCompanyName,
      })
      // setMessage("Please select fax from the list")

      setTransferComplete(true)
      setTimeout(() => {
        fetchFaxes()
      }, 2000)
    } catch (error) {
      setErrorMessage("Failed to resend fax. Please try again.")
    } finally {
      setLoadingResend(false)
    }
  }

  const resetForm = () => {
    setRecipientFaxNum("")
    setRecipientName("")
    //setRecipientCompanyName("")
  }

  const handleCancel = () => {
    setShowPopup(false)
    setErrorMessage("")
    setTransferComplete(false)
    resetForm()
  }

  const fetchFax = async () => {
    setFax({})
    setLoadingResend(false)
    setLoading(false)

    try {
      setLoading(true)
      const data = await get(
        `/fax/fetchFaxImage?faxId=${selectedFax.faxId}&selectedTab=${selectedTab}`
      )

      if (data?.image) {
        // const byteCharacters = atob(data?.image)
        // const byteNumbers = new Array(byteCharacters.length)
        // for (let i = 0; i < byteCharacters.length; i++) {
        //   byteNumbers[i] = byteCharacters.charCodeAt(i)
        // }
        // const byteArray = new Uint8Array(byteNumbers)
        // const blob = new Blob([byteArray], { type: "application/pdf" })

        // // Update state to pass the Blob to the Document component
        // setPdfUrl(blob)

        setDocImage(data?.image)
      } else {
        setDocImage(null)
      }

      setFax(data)
      setLoading(false)
    } catch (err) {
      setLoading(false)
      setDocImage(null)
    }
  }

  useEffect(() => {
    if (selectedFax?.faxId) fetchFax()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFax?.faxId])

  return (
    <div className="fax-view">
      <div className="fax-view-buttons">
        <button
          className={`${!fax?.image ? "disabled" : ""}`}
          disabled={!fax?.image ? true : false}
          onClick={() => handleButtonClick("Download")}
        >
          Download
        </button>
        <p>&nbsp;</p>
        {(selectedTab === "FAILED_FAX" || selectedTab === "365_DAY_FAX") && (
          <>
            <button
              className={`${!fax?.image ? "disabled" : ""}`}
              disabled={!fax?.image ? true : false}
              onClick={() => handleButtonClick("Resend")}
            >
              Resend
            </button>
          </>
        )}
      </div>
      <div className="fax-view-data">
        <div className="data-item">
          <span className="data-label">Fax Id:</span>
          <span className="data-value">{selectedFax?.faxId}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Originating Fax Number:</span>
          <span className="data-value">{selectedFax?.originFaxNum}</span>
        </div>
        <div className="data-item">
          <span className="data-label">Destination Fax Number:</span>
          <span className="data-value">{selectedFax?.destFaxNum}</span>
        </div>
      </div>
      <div className="fax-view-image">
        {fax.image ? (
          // <PdfViewer pdfUrl={pdfUrl} />
          <PdfViewer base64String={docImage} loading={loading} />
        ) : loading ? (
          <div className="loading-container">
            <div className="loading-pdf-message">Loading ...</div>
          </div>
        ) : (
          <p>PDF not available</p>
        )}
      </div>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            {transferComplete ? (
              <div className="success-message">
                <span
                  style={{
                    color: "green",
                    fontSize: "48px",
                  }}
                >
                  ✅
                </span>
                <p>Fax has been resent successfully</p>
                <button onClick={handleCancel}>Close</button>
              </div>
            ) : loadingResend ? (
              <div className="transfer-animation">
                <p>Transferring fax...</p>
                <div className="file-transfer-animation"></div>
              </div>
            ) : (
              <>
                <h3>Resend Fax</h3>
                <form className="popup-group" onSubmit={handlePopupSubmit}>
                  <div className="form-group">
                    <label htmlFor="recipientFaxNum">
                      Recipient Fax Number
                    </label>
                    <input
                      type="text"
                      id="recipientFaxNum"
                      value={recipientFaxNum || ""}
                      onChange={(e) => setRecipientFaxNum(e.target.value)}
                    />
                    {/* Note: Special characters will be ignored */}
                  </div>
                  <div className="form-group">
                    <label htmlFor="recipientName">Recipient Name</label>
                    <input
                      type="text"
                      id="recipientName"
                      value={recipientName || ""}
                      onChange={(e) => setRecipientName(e.target.value)}
                    />
                  </div>
                  {/*
                  <div className="form-group">
                    <label htmlFor="recipientCompanyName">
                      Recipient Company Name
                    </label>
                    <input
                      type="text"
                      id="recipientCompanyName"
                      value={recipientCompanyName}
                      onChange={(e) => setRecipientCompanyName(e.target.value)}
                    />
                  </div>
                  */}
                  {errorMessage && (
                    <div className="error-message">{errorMessage}</div>
                  )}
                  <div className="popup-buttons">
                    <button type="button" onClick={handleCancel}>
                      Cancel
                    </button>
                    <button type="submit" disabled={loadingResend}>
                      {loadingResend ? "Sending..." : "Send"}
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default FaxView
